module.exports = __webpack_public_path__ + "img/contact-left.461dfbb3.jpg";